import axios from 'axios';
import React, { useEffect, useState } from 'react';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Container,
  Row,
  Col,
  Input,
  Label,
  Table,
  Button,
} from 'reactstrap';

import { API_BASE_URL } from '../../../Config';

const Price = ({ next_step, prev_step, price_id, set_price_id }) => {
  const [plans, setPlans] = useState([]);
  const [features, setFeatures] = useState([]);

  async function load_price() {
    console.log('loading price data..');
    const response = await axios.get(`${API_BASE_URL}/plans/`);
    const data = response.data;
    console.log(data);
    if (data.plans) {
      setPlans(data.plans);
    }

    if (data.features) {
      setFeatures(data.features);
    }
    console.log('price data is loaded successfully..');
  }

  useEffect(() => {
    load_price();
  }, []);

  const handle_get_price = (e, id) => {
    console.log('handle_submit');
    set_price_id(id);
    next_step();
  };

  return (
    <Card className="w-100 text-center">
      <CardBody>
        <Table borderless>
          <thead>
            <tr style={{ borderBottom: '1px solid #a5a0a0' }}>
              <th>Feature/Limit</th>

              {plans &&
                plans.length > 0 &&
                plans.map((plan_ele, index) => (
                  <th key={{ index }}>
                    <h5 className="title name fw-bold text-uppercase mb-1">
                      {index === 0 ? (
                        <>
                          <i
                            className="uil uil-rocket fs-3"
                            style={{ color: '#fd7e14' }}
                          ></i>
                          <span
                            className="fs-6 fst-italic"
                            style={{ fontWeight: 'normal' }}
                          >
                            {plan_ele.name}
                          </span>
                        </>
                      ) : (
                        <>
                          <i
                            className="uil uil-users-alt fs-3"
                            style={{ color: '#082f54' }}
                          ></i>
                          <span
                            className="fs-6 fst-italic"
                            style={{ fontWeight: 'normal' }}
                          >
                            {plan_ele.name}(Most Popular)
                          </span>
                        </>
                      )}
                    </h5>
                    <div className="d-flex justify-content-center mb-2">
                      <span className="h6 mb-0 mt-2">$</span>
                      <span className="price h2 mb-0">
                        {plan_ele.price_set[0].amt}
                      </span>
                      <span className="h6 align-self-end mb-1">/mo</span>
                    </div>
                  </th>
                ))}
            </tr>
          </thead>

          <tbody>
            {features &&
              features.length > 0 &&
              features.map((feature_ele, index) => (
                <tr
                  key={{ index }}
                  style={{ borderBottom: '1px solid #e0d9d9' }}
                >
                  <th scope="row">{feature_ele.detail}</th>

                  {feature_ele.planspecificfeature_set.map(
                    (plaspcfea_ele, plaspcfea_i) => (
                      <th key={{ plaspcfea_i }} scope="row">
                        <h6>
                          <span>{plaspcfea_ele.detail}</span>
                        </h6>
                      </th>
                    ),
                  )}
                </tr>
              ))}
          </tbody>

          <tr>
            <th scope="row"></th>
            {plans &&
              plans.map((plan_ele, index) => (
                <th key={{ index }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <Button
                      color="primary"
                      onClick={(e) =>
                        handle_get_price(e, plan_ele.price_set[0].id)
                      }
                    >
                      Next
                    </Button>
                  </div>
                </th>
              ))}
          </tr>
        </Table>

        <Container className="">
          <div className="mt-4 text-start ms-3">
            <h5 className="mb-0">Core Features Included on Every Plan</h5>
            Every account has access to our lightweight, custom-built real-time
            core infrastructure:
          </div>

          <div className="d-flex flex-column ms-3 mt-2">
            <div className="text-start">
              <h6 className="mb-0 fw-bold">
                The All-in-One Dashboard:{' '}
                <span className="fs-6 ms-2" style={{ fontWeight: 'normal' }}>
                  A centralized, web-based workspace to track, claim, and reply
                  to website visitors instantly.
                </span>
              </h6>
            </div>

            <div className="text-start">
              <h6 className="mb-0 fw-bold">
                Instant WebSocket Messaging:
                <span className="fs-6 ms-2" style={{ fontWeight: 'normal' }}>
                  Lag-free, real-time message streaming between agents and
                  visitors.
                </span>
              </h6>
            </div>

            <div className="text-start">
              <h6 className="mb-0 fw-bold">
                Mobile-Responsive Interface:
                <span className="fs-6 ms-2" style={{ fontWeight: 'normal' }}>
                  Easily check your inbox and handle incoming customer chats
                  straight from any phone or tablet browser.
                </span>
              </h6>
            </div>
          </div>
        </Container>
      </CardBody>
    </Card>
  );
};

export default Price;
